<template>
    <div>
        <el-dropdown class="d2-mr">
            <span class="btn-text">你好 {{userInfo.name}}</span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="isUpdatePwd" @click.native="dialogVisible=true">
                    <i class="fa fa-key" aria-hidden="true"></i>
                    修改密码
                </el-dropdown-item>
                <el-dropdown-item @click.native="$emit('logout')">
                    <d2-icon name="power-off" class="d2-mr-5"/>
                    注销
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="修改密码" :visible.sync="dialogVisible" width="800px" center>
            <system-pwd/>
        </el-dialog>
    </div>
</template>

<script>
//import { mapState, mapActions } from 'vuex'
import SystemPwd from './../../../../pages/system/pwd'

export default {
    name: 'ZebraHeaderUser',
    components: {
        SystemPwd
    },
    props: {
       userInfo: {
           type: Object,
           required: true
       },
        isUpdatePwd: {
           type: Boolean,
           default: true
        },
        updatePwdUrl: {
           type: String,
            default: '/system/pwd'
        }
    },
    data(){
        return {
            dialogVisible: false
        }
    },
    methods: {
        gotoRouterPath (path) {
            this.$router.push({path: path})
        }
    }
 /* computed: {
    ...mapState({
      userInfo: state => state.d2admin.userInfo
    })
  },*/
  /*methods: {
    ...mapActions([
      'd2adminLogout'
    ]),
    /!**
     * @description 登出
     *!/
    logOff () {
      this.d2adminLogout({
        vm: this,
        confirm: true
      })
    }
  }*/
}
</script>
